import api from "../utils/api";
import { isGuid } from "../utils/string";
import { isEmail } from "../utils/regex";
import {
    LOGOUT
} from "./types";
import { pack } from "./alert";

const failure = (err, fallback) => ({
    success: false,
    fatal: true,
    status: err?.response?.status || 500,
    message: err?.response?.data?.message || err?.response?.data?.error?.message || err?.message || fallback,
    error: err?.response?.data?.error || err?.response?.data || null
});

export const search = ({ page = 0, size = 10, order = "email", direction = "asc", search = null }) => async (dispatch) => {
    try {
        const res = await api.get(`/users/p/${page}/s/${size}/o/${order}/${direction}/${search}`);
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        return failure(err, "User search failed");
    }
}

export const get = ({ uuid, email }) => async (dispatch) => {
    try {
        const res = isGuid(uuid) ? await api.get(`/users/i/${uuid}`) : isEmail(email) ? await api.get(`/users/e/${email}`) : { data: { success: false }} ;
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        return failure(err, "User lookup failed");
    }
}

export const apply = ({ userUuid, email }) => async (dispatch) => {
    try {
        const res = await api.post(`/users/apply`, { userUuid, email });
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        return failure(err, "User instance apply failed");
    }
}

export const save = ({ userUuid, email, phone, whitelist, resetRequired = false }) => async (dispatch) => {
    try {
        const res = await api.post(`/users`, { userUuid, email, phone, whitelist, resetRequired });
        if (res.data?.success === false || res.data?.fatal) return res.data;
        dispatch(pack(["user information saved"], "success"));
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        return failure(err, "User save failed");
    }
}
